// extracted by mini-css-extract-plugin
export default {"wrapper":"_1rsAI___Layout-module__wrapper","tabs":"_1Qr-X___Layout-module__tabs"};